import React from 'react';
import { IconChevronRight } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import useWizardStore from '@features/wizard/store/useWizardStore';

interface BreadcrumbItem {
  labelKey: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const { t } = useTranslation();
  const isSessionStarted = useWizardStore((s) => s.isSessionStarted);

  return (
    <nav
      className="flex items-center text-sm overflow-hidden"
      aria-label="Breadcrumb"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isSmallScreenHidden =
          items.length > 3 && index !== 0 && index !== items.length - 1;

        return (
          <div
            key={index}
            className={`flex items-center ${isSmallScreenHidden ? 'hidden sm:flex' : ''}`}
          >
            {isLast ? (
              <span className='truncate max-w-[100px] md:max-w-none font-semibold text-primary dark:text-sky-400'>
                {t(item.labelKey)}
              </span>
            ) : (
              <a
                data-qa-id={`return-link-${(item.labelKey).substring(11).replace(/\s+/g, '').toLowerCase()}`}
                href={isSessionStarted ? undefined : item.href}
                className={`${isSessionStarted ? 'cursor-not-allowed' : 'hover:text-primary'} transition-colors text-muted-foreground truncate max-w-[100px] md:max-w-none`}
              >
                {t(item.labelKey)}
              </a>
            )}

            {!isLast && (
              <IconChevronRight
                className="mx-2 text-muted-foreground/60"
                size={16}
              />
            )}
          </div>
        );
      })}

      {items.length > 3 && (
        <div className="flex sm:hidden items-center">
          <span className="text-muted-foreground font-medium">...</span>
          <IconChevronRight
            className="mx-2 text-muted-foreground/60"
            size={16}
          />
        </div>
      )}
    </nav>
  );
};

export default Breadcrumb;
